/* eslint-disable global-require */
module.exports = ['footer.marketplace_legals', 'login._modal.html.m6'];
